import { signal } from "@preact/signals";

export type Route = "today" | "library" | "map" | "progress" | "settings" | "onboarding";

const PATH_FOR_ROUTE: Record<Route, string> = {
  today: "/",
  library: "/library",
  map: "/map",
  progress: "/progress",
  settings: "/settings",
  onboarding: "/onboarding",
};

function routeFromPath(path: string): Route {
  if (path.startsWith("/library")) return "library";
  if (path.startsWith("/map")) return "map";
  if (path.startsWith("/progress")) return "progress";
  if (path.startsWith("/settings")) return "settings";
  if (path.startsWith("/onboarding")) return "onboarding";
  return "today";
}

export const route = signal<Route>(typeof location !== "undefined" ? routeFromPath(location.pathname) : "today");

export function navigate(next: Route): void {
  if (route.value === next) return;
  route.value = next;
  history.pushState({}, "", PATH_FOR_ROUTE[next]);
}

if (typeof window !== "undefined") {
  window.addEventListener("popstate", () => {
    route.value = routeFromPath(location.pathname);
  });
}
